<template>
    <div class="dashboard">
        <v-card class="my-4">
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <h2>{{$t('MAIN.TOTAL_POLICY')}}: {{(parseInt(travel_count.total_policy)) | numeral('0,0')}} </h2>
                    </v-col>

                    <v-col cols="12" md="6">
                        <h2>{{$t('MAIN.TOTAL_GWP')}}: <span class="red--text">{{(parseInt(travel_count.total_premium)) | numeral('0,0')}}</span> LAK</h2>
                    </v-col>

                </v-row>
                <v-divider class="my-4"></v-divider>
                <v-row>
                    <v-col cols="12">
                        <line-chart v-if="chart_data_loaded" :chart-data="line_chart"></line-chart>
                    </v-col>
                </v-row>
            </v-card-text>

        </v-card>
    </div>
</template>

<script>
    import LineChart from "@/components/LineChart";
    export default {
        name: "DashBoard",
        components: {LineChart},
        data:()=>({
            chart_data_loaded: false,

            travel_count:{},

            line_chart:{
                labels: ['1','2','3'],
                datasets: [
                    {
                        label: 'Travel',
                        backgroundColor: '#FF9800',
                        lineTension:0.4,
                        data: [10,20,30]
                    },


                ]
            }
        }),
        mounted() {
            this.getData()
        },
        methods:{
            async getData(){
                try {
                    this.chart_data_loaded=false
                    const r=await window.axios.get('travel/board')
                    console.log(r.data.count_data[0])
                    this.line_chart.labels=r.data.travel.title
                    this.line_chart.datasets[0].data=r.data.travel.amount


                    this.travel_count=r.data.count_data[0]

                    this.chart_data_loaded=true
                }catch (e) {
                    console.log(e)
                }
            }
        }
    }
</script>

<style scoped>

</style>